import UserMessagesInbox from './user_messages/user_messages_inbox';

class UserMessagesInitializer {
  constructor() {
    let inbox = document.querySelector('[data-user-messages-inbox]');

    if (!(inbox instanceof HTMLElement)) {
      return;
    }

    new UserMessagesInbox(inbox);
  }
}

export default UserMessagesInitializer;



// WEBPACK FOOTER //
// ./src/javascripts/UserMessagesInitializer.js